import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Essentials,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  FontFamily,
  FontSize,
  FontColor,
  FontBackgroundColor,
  RemoveFormat,
  Paragraph,
  Heading,
  List,
  Link,
  BlockQuote,
  Indent,
  Alignment,
  Table,
  TableToolbar,
  TableProperties,
  TableCellProperties,
  TableColumnResize,
  TableCaption,
  ImageBlock,
  ImageInline,
  ImageUpload,
  ImageToolbar,
  ImageInsertViaUrl,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageCaption,
  PictureEditing,
  LinkImage
} from 'ckeditor5';
import MyCustomUploadAdapterPlugin from 'util/plugin/customUploadAdapter';
import 'ckeditor5/ckeditor5.css';

// 따옴표로 감싼 한글 글꼴명('맑은 고딕')은 백엔드 HtmlSanitizer가 제거해 font-family 전체가 무효가 되므로
// CSS 값은 영문 글꼴명만 쓰고 드롭다운 표시명만 한글로 지정
const fontFamilyOption = (title, fontFamily) => ({
  title,
  model: fontFamily,
  view: { name: 'span', styles: { 'font-family': fontFamily }, priority: 7 }
});

const FONT_FAMILY_OPTIONS = [
  'default',
  fontFamilyOption('맑은 고딕', "'Malgun Gothic', sans-serif"),
  fontFamilyOption('나눔고딕', "NanumGothic, 'Nanum Gothic', sans-serif"),
  fontFamilyOption('돋움', 'Dotum, sans-serif'),
  fontFamilyOption('굴림', 'Gulim, sans-serif'),
  fontFamilyOption('바탕', 'Batang, serif'),
  fontFamilyOption('궁서', 'Gungsuh, serif'),
  fontFamilyOption('Arial', 'Arial, sans-serif'),
  fontFamilyOption('Times New Roman', "'Times New Roman', serif")
];

// 양식 변수 longtext 필드용 CKEditor (Table + Image 지원)
export default function SimpleEditor({ data = '', onChange, placeholder = '내용을 입력하세요', minHeight = 120, board }) {
  return (
    <div style={{ '--ck-border-radius': '4px' }}>
      <CKEditor
        editor={ClassicEditor}
        config={{
          plugins: [
            Essentials,
            Bold,
            Italic,
            Underline,
            Strikethrough,
            FontFamily,
            FontSize,
            FontColor,
            FontBackgroundColor,
            RemoveFormat,
            Paragraph,
            Heading,
            List,
            Link,
            BlockQuote,
            Indent,
            Alignment,
            Table,
            TableToolbar,
            TableProperties,
            TableCellProperties,
            TableColumnResize,
            TableCaption,
            ImageBlock,
            ImageInline,
            ImageUpload,
            ImageToolbar,
            ImageInsertViaUrl,
            ImageResize,
            ImageStyle,
            ImageTextAlternative,
            ImageCaption,
            PictureEditing,
            LinkImage
          ],
          extraPlugins: [MyCustomUploadAdapterPlugin],
          // 가로줄·형광펜·동영상은 백엔드 HtmlSanitizer가 저장 시 제거하므로 제외
          toolbar: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'fontFamily',
            'fontSize',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'alignment',
            'outdent',
            'indent',
            'blockQuote',
            '|',
            'link',
            '|',
            'insertTable',
            '|',
            'insertImage',
            '|',
            'removeFormat'
          ],
          // 숫자 옵션만 사용: 'tiny'/'big' 등 이름 옵션은 class로 출력돼 HtmlSanitizer에서 제거됨
          fontFamily: {
            options: FONT_FAMILY_OPTIONS
          },
          fontSize: {
            options: ['default', 10, 12, 14, 16, 18, 20, 22]
          },
          table: {
            contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
          },
          image: {
            toolbar: [
              'imageStyle:inline',
              'imageStyle:block',
              'imageStyle:side',
              '|',
              'toggleImageCaption',
              'imageTextAlternative',
              '|',
              'resizeImage'
            ]
          },
          board,
          placeholder,
          ui: { viewportOffset: { top: 60 } }
        }}
        data={data}
        onChange={(event, editor) => {
          if (onChange) onChange(editor.getData());
        }}
      />
      <style>{`
        .ck-editor__editable { min-height: ${minHeight}px; }
      `}</style>
    </div>
  );
}
